// Slice 40 — keyboard-shortcut chip. Mono, dim.

import type { ReactNode } from "react";

export function HqKbd({ children }: { children: ReactNode }) {
  return (
    <span
      className="hq-mono"
      style={{
        display: "inline-flex",
        alignItems: "center",
        height: 18,
        padding: "0 5px",
        borderRadius: 4,
        background: "var(--hq-bg-input)",
        color: "var(--hq-text-dim)",
        border: "1px solid var(--hq-border-input)",
        fontSize: 10,
        fontWeight: 500,
      }}
    >
      {children}
    </span>
  );
}
